module.exports = __webpack_public_path__ + "static/media/merchant-nation.1d39c067.mp4";